import { forwardRef } from "react";

import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import type { HeroV2DiscountType } from "../types/HeroV2Types";

import styles from "./Promotions.module.scss";

const { sanitize } = dompurify;

type PromotionsProps = {
  discounts?: HeroV2DiscountType[];
  legalDisclaimer?: string;
  isContainerWidth?: boolean;
  theme?: "dark" | "light" | "inherit";
};

export const Promotions = forwardRef<HTMLDivElement, PromotionsProps>(
  ({ discounts = [], legalDisclaimer, theme = "inherit" }, ref) => {
    return (
      <div
        className={classNames(styles.promotionDisclaimer, {
          "dark-theme": theme === "dark",
          "light-theme": theme === "light",
        })}
        ref={ref}
        data-testid="promotions"
      >
        <div className={styles.promotionDisclaimerInner}>
          {discounts.length > 0 && (
            <div className={styles.promotionDisclaimerContent}>
              {discounts.map((discount, index) => (
                <span key={`${index}-${discount.priceDisclaimer}`}>{discount.priceDisclaimer}</span>
              ))}
            </div>
          )}
          {legalDisclaimer && (
            <span
              className={styles.legalDisclaimer}
              dangerouslySetInnerHTML={{
                __html: sanitize(legalDisclaimer),
              }}
            ></span>
          )}
        </div>
      </div>
    );
  }
);

Promotions.displayName = "Promotions";
